import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";

const Terms = () => {
  return (
    <>
    {/* <Header/> */}
    <IndiaBoatsTopBar />
      <PremiumNavbar />
    <>
  <div className="breadcumb-wrapper" style={{ padding: "50px 0" }}>
    <div className="container">
      <div className="breadcumb-content">
        <h1 className="breadcumb-title">Terms of Use</h1>
        {/* <ul class="breadcumb-menu">
          <li><a href="home-travel.html">Home</a></li>
          <li>About Tourm</li>
      </ul> */}
      </div>
    </div>
  </div>
  {/*======== / Hero Section ========*/}
  {/*==============================
Booking Area  
==============================*/}
  {/*==============================
About Area  
==============================*/}
  <div
    className="about-area position-relative overflow-hidden overflow-hidden space"
    style={{ padding: "30px 0" }}
    id="about-sec"
  >
    <div className="container">
      <div className="row">
        <div className="col-xl-12">
          <div className="termsofuse">
            The www.Indiaboats.in (“IndiaBoats”) website ("Website") is an
            internet based Yacht chartering and shopping portal owned and
            operated by Aquartia Pvt. Ltd. (“Aquartia”) incorporated under the
            laws of India, with its registered office at 803 Hubtown VIVA,
            Western Express Highway, Shankerwadi, Mumbai 400060.
            <p>
              Through the Website, Aquartia shall provide you ("User") Yachts
              related information, pricing, availability and reservations for
              charter, for shopping, purchase and sale of boats, across cities
              throughout India ("Service"), as more particularly described and
              defined in the terms of service ("TOS") relating to such Service,
              This Service may be availed by the User, his family members and
              friends in India at any time during the year through vendors
              ("Service Providers").
            </p>
            <p>
              This User Agreement ("Agreement") sets out the terms and
              conditions on which Aquartia shall provide the Services to the
              User through the Website. In addition to this Agreement and
              depending on the Services opted for by the User, the User shall be
              required to read and accept the relevant TOS for such Service,
              which may be updated or modified by Aquartia from time to time.
              Such TOS shall be deemed to be a part of this Agreement and in the
              event of a conflict between such TOS and this Agreement, the terms
              of this Agreement shall prevail.
            </p>
            <p>
              Use of the Website is offered to the User conditioned on
              acceptance without modification of all the terms, conditions and
              notices contained in this Agreement and the TOS, as may be posted
              on the Website from time to time. For the removal of doubts, it is
              clarified that use of the Website by the User constitutes an
              acknowledgement and acceptance by the User of this Agreement and
              the TOS. If the User does not agree with any part of such terms,
              conditions and notices, the User must not use the Website.
            </p>
            <p>
              Additionally, the Service Provider may provide terms and
              guidelines that govern particular features, offers or the
              operating rules and policies applicable to each Service (for
              example, booking terms, discounts, gift vouchers, Combo?, etc.).
              The User shall be responsible for ensuring compliance with the
              terms and guidelines or operating rules and policies of the
              Service Provider with whom the User elects to deal, including
              terms and conditions set forth in a Service Providers. In the
              event that any of the terms, conditions and notices contained in
              this Agreement or the TOS conflict with the additional/other terms
              and guidelines specified by the Service Provider, then the latter
              terms/guidelines shall prevail.
            </p>
            <p>
              Aquartia reserves the right to change the terms, conditions and
              notices under which the Services are offered through the Website,
              including but not limited to the charges for the Services provided
              through the Website. The User shall be responsible for regularly
              reviewing these terms and conditions.
            </p>
            <p>
              The User agrees and undertakes not to sell, trade or resell or
              exploit for any commercial purposes, any portion of the Service.
              For the removal of doubt, it is clarified that the Website is not
              for commercial use but is specifically meant for personal use
              only.
            </p>
            <p>
              The User further agrees and undertakes not to reverse engineer,
              modify, copy, distribute, transmit, display, perform, reproduce,
              publish, license, create derivative works from, transfer, or sell
              any information, software, products or services obtained from the
              Website. Limited reproduction and copying of the content of the
              Website is permitted provided that the IndiaBoats name is stated
              as the source. For the removal of doubt, it is clarified that
              unlimited or wholesale reproduction, copying of the content for
              commercial or non-commercial purposes and unwarranted modification
              of data and information within the content of the Website is not
              permitted.
              <br />
            </p>
            <p>
              Aquartia has endeavored to ensure that all the information on the
              website is correct, but Aquartia neither warrants nor makes any
              representations regarding the quality, accuracy or completeness of
              any data or information contained. Aquartia makes no warranty,
              express or implied, concerning the website and/or its contents and
              disclaims all warranties of fitness for a particular purpose and
              warranties of merchantability in respect of services, including
              any liability, responsibility or any other claim, whatsoever, in
              respect of any loss, whether direct or consequential, to any user
              or any other person, arising out of or from the use of the
              information contained in the website.
            </p>
            <p>
              <br />
              Since Aquartia (‘IndiaBoats) acts only as a booking agent, it
              shall not have any liability whatsoever for any aspect of the
              arrangements between the service provider and the user as regards
              the standards of services provided by the service providers. In no
              circumstances shall Aquartia (‘IndiaBoats) be liable for the
              services provided by the service provider.
            </p>
            <p>
              Although Aquartia (‘IndiaBoats) makes reasonable commercial
              efforts to ensure that the description and content in the TOS and
              on each page of the website is correct, it does not, however, take
              responsibility for changes that occurred due to human or data
              entry errors or for any loss or damages suffered by any user due
              to any information contained herein. Also, Aquartia (‘IndiaBoats)
              is not the service provider and cannot therefore control or
              prevent changes in the published descriptions which are based upon
              information provided by the service providers.
            </p>
            <p>
              Aquartia (‘IndiaBoats) does not endorse any advertiser on its
              website in any manner. The users are requested to verify the
              accuracy of all information on their own before undertaking any
              reliance on such information.
            </p>
            <p>
              In no event shall Aquartia (‘IndiaBoats) be liable for any direct,
              indirect, punitive, incidental, special, consequential damages or
              any other damages resulting from: (a) the use or the inability to
              use the services; (b) the cost of procurement of substitute goods
              and services or resulting from any goods, information or services
              purchased or obtained or messages received or transactions entered
              into through the services; (c) unauthorized access to or
              alteration of the user's transmissions or data; (d) any other
              matter relating to the services; including, without limitation,
              damages for loss of use, data or profits, arising out of or in any
              way connected with the use or performance of the website. Neither
              shall Aquartia (‘IndiaBoats) be responsible for the delay or
              inability to use the website or related services, the provision of
              or failure to provide services, or for any information, software,
              products, services and related graphics obtained through the
              website, or otherwise arising out of the use of the website,
              whether based on contract, tort, negligence, strict liability or
              otherwise. further, Aquartia (‘IndiaBoats) shall not be held
              responsible for non-availability of the website during periodic
              maintenance operations or any unplanned suspension of access to
              the website that may occur due to technical reasons or for any
              reason beyond Aquartia (‘IndiaBoats) control. the user understands
              and agrees that any material and/or data downloaded or otherwise
              obtained through the website is done entirely at their own
              discretion and risk and they will be solely responsible for any
              damage to their computer systems or loss of data that results from
              the download of such material and/or data. These limitations,
              disclaimer of warranties and exclusions apply without regard to
              whether the damages arise from (a) breach of contract, (b) breach
              of warranty, (c) negligence, or (d) any other cause of action, to
              the extent such exclusion and limitations are not prohibited by
              applicable law.the maximum liability on part of Aquartia
              (‘IndiaBoats) arising under any circumstances, in respect of any
              services offered on the site, shall be limited to the refund of
              total amount received from the customer for availing the services
              less any cancellation, refund or others charges, as may be
              applicable. in no case the liability shall include any
              consequential loss, damage or additional expense whatsoever.
              <br />
            </p>
            <p>
              The Website may contain links to other websites ("Linked Sites").
              The Linked Sites are not under the control of Aquartia
              (‘IndiaBoats) or the Website and Aquartia (‘IndiaBoats) is not
              responsible for the contents of any Linked Site, including without
              limitation any link contained in a Linked Site, or any changes or
              updates to a Linked Site. Aquartia (‘IndiaBoats) is not
              responsible for any form of transmission, whatsoever, received by
              the User from any Linked Site. Aquartia (‘IndiaBoats) is providing
              these links to the User only as a convenience, and the inclusion
              of any link does not imply endorsement by Aquartia (‘IndiaBoats)
              or the Website of the Linked Sites or any association with its
              operators or owners including the legal heirs or assigns thereof.
            </p>
            <p>
              Aquartia (‘IndiaBoats) is not responsible for any errors,
              omissions or representations on any Linked Site. Aquartia
              (‘IndiaBoats) does not endorse any advertiser on any Linked Site
              in any manner. The Users are requested to verify the accuracy of
              all information on their own before undertaking any reliance on
              such information.
              <br />
            </p>
            <p>
              As a condition of the use of the Website, the User warrants that
              they will not use the Website for any purpose that is unlawful or
              illegal under any law for the time being in force within or
              outside India or prohibited by this Agreement and/or the TOS
              including both specific and implied. In addition, the Website
              shall not be used in any manner, which could damage, disable,
              overburden or impair it or interfere with any other party's use
              and/or enjoyment of the Website. The User shall refrain from
              obtaining or attempting to obtain any materials or information
              through any means not intentionally made available or provided for
              or through the Website.
            </p>
            <p>
              The Website may contain services such as email, chat, bulletin
              board services, information related to recommendations, news
              groups, forums, communities, personal web pages, calendars, and/or
              other message (hereinafter collectively referred to as
              "Communication Services"). The User agrees and undertakes to use
              the Communication Services only to post, send and receive messages
              and material that are proper and related to the particular
              Communication Service. By way of example, and not as a limitation,
              the User agrees and undertakes that when using a Communication
              Service, the User will not:
            </p>
            <ul>
              <li>
                defame abuse, harass, stalk, threaten or otherwise violate the
                legal rights of others;
                <br />
              </li>
              <li>
                upload files that contain software or other material protected
                by intellectual property laws unless the User owns or controls
                the rights thereto or have received all necessary consents;
                <br />
              </li>
              <li>
                upload or distribute files that contain viruses, corrupted
                files, or any other similar software or programs that may damage
                the operation of the Website or another's computer;
                <br />
              </li>
              <li>
                advertise or offer to sell or buy any goods or services for any
                business purpose, unless such Communication Service specifically
                allows such messages;
                <br />
              </li>
              <li>
                conduct or forward surveys, contests, pyramid schemes or chain
                letters;
                <br />
              </li>
              <li>
                download any file posted by another user of a Communication
                Service that the User know, or reasonably should know, cannot be
                legally distributed in such manner;
                <br />
              </li>
              <li>
                falsify or delete any author attributions, legal or other proper
                notices or proprietary designations or labels of the origin or
                source of software or other material contained in a file that is
                uploaded;
                <br />
              </li>
              <li>
                violate any code of conduct or other guidelines, which may be
                applicable for or to any particular Communication Service;
                <br />
              </li>
              <li>
                violate any applicable laws or regulations for the time being in
                force in or outside India; and
                <br />
              </li>
              <li>
                violate any of the terms and conditions of this Agreement or any
                other terms and conditions for the use of the Website contained
                elsewhere herein.
              </li>
            </ul>
            <p>
              B Aquartia (‘IndiaBoats) has no obligation to monitor the
              Communication Services. However, Aquartia (‘IndiaBoats) reserves
              the right to review materials posted through Communication Service
              and to remove any materials in its sole discretion. Aquartia
              (‘IndiaBoats) reserves the right to terminate the User's access to
              any or all of the Communication Services at any time without
              notice for any reason whatsoever.
            </p>
            <p>
              Aquartia (‘IndiaBoats) reserves the right at all times to disclose
              any information as is necessary to satisfy or comply with any
              applicable law, regulation, legal process or governmental request,
              or to edit, refuse to post or to remove any information or
              materials, in whole or in part, in Aquartia (‘IndiaBoats) sole
              discretion.
            </p>
            <p>
              Aquartia (‘IndiaBoats) does not control or endorse the content,
              messages or information found in any communication service and,
              therefore, Aquartia (‘IndiaBoats) specifically disclaims any
              liability or responsibility whatsoever with regard to the
              communication services and any actions resulting from the user's
              participation in any communication service.
            </p>
            <p>
              Materials uploaded to a Communication Service may be subject to
              posted limitations on usage, reproduction and/or dissemination.
              User is responsible for keeping himself updated of and adhering to
              such limitations if they download the materials.
              <br />
            </p>
            <p>
              Aquartia (‘IndiaBoats) reserves the right, in its sole discretion,
              to terminate the access to the website and the related services or
              any portion thereof at any time, without notice.
              <br />
            </p>
            <p>
              Aquartia (‘IndiaBoats) reserves the right to charge listing fees
              for certain listings, as well as transaction fees based on certain
              completed transactions using the Aquartia (‘IndiaBoats) Services.
              Aquartia (‘IndiaBoats) further reserves the right to alter any and
              all fees from time to time, without notice.
            </p>
            <p>
              The User shall be liable to pay all applicable charges, fees,
              duties, taxes, levies and assessments for availing the Aquartia
              (‘IndiaBoats) Services.
              <br />
            </p>
            <p>
              In consideration of use of the Website, the User represent and
              confirm that the User is of legal age to enter into a binding
              contract and is not a person barred from using the Website and/or
              receiving the Services under the laws of India or other applicable
              law.
            </p>
            <p>
              To avail a Service the User has and must continue to maintain at
              his sole cost: (a) all the necessary equipment’s including a
              computer and modem etc. to access the Website/avail Services; (b)
              own access to the World Wide Web. The User shall be responsible
              for accessing the Services and that access may involve third party
              fees including, airtime charges or internet service provider?s
              charges which are to be exclusively borne by the User.
            </p>
            <p>
              The user also understands that the services may include certain
              communications from Aquartia (‘IndiaBoats) as service
              announcements and administrative messages. The user understands
              and agrees that the services are provided on an "as is" basis and
              that Aquartia (‘IndiaBoats) does not assume any responsibility for
              deletions, mis-delivery or failure to store any user
              communications or personalized settings.
              <br />
            </p>
            <p>
              Registration of the User on the Website is optional. If the User
              opts to register himself on the Website, upon completion of the
              registration process, the User shall receive a user id and
              password. The User agrees and undertakes at all times to be
              responsible for maintaining the confidentiality of the password
              and user id, and shall be fully responsible for all activities
              that occur by use of such password or user id. Further, the User
              agrees not to use any other party's user id and password for any
              purpose whatsoever without proper authorization from such party.
              You are responsible for the security of your password and for all
              transactions undertaken using your password through our service.
              The Password entered by you is transmitted in one- way encrypted
              form to our database and stored as such. Thus the Password will
              not be known even to Aquartia (‘IndiaBoats). You confirm that you
              are the authorised holder of the credit card or the original
              account holder used in the transactions you make using the
              Aquartia (‘IndiaBoats) services. Aquartia (‘IndiaBoats) will not
              be responsible for any financial loss, inconvenience or mental
              agony resulting from misuse of your ID/password/credit card
              number/account details number for using Aquartia (‘IndiaBoats)
              Services.
            </p>
            <p>
              The user also agrees and undertakes to immediately notify Aquartia
              (‘IndiaBoats) of any unauthorized use of the user's password or
              user id and to ensure that the user logs off at the end of each
              session at the website. Aquartia (‘IndiaBoats) shall not be
              responsible for any, direct or indirect, loss or damage arising
              out of the user's failure to comply with this requirement.
            </p>
            <p>
              The User also agrees to: (a) provide true, accurate and complete
              information about himself and his beneficiaries as prompted by the
              registration form ("Registration Data") on the Website; and (b)
              maintain and promptly update the Registration Data to keep it
              true, accurate, current and complete. If the User provide any
              information that is untrue, inaccurate, not current or incomplete
              or Aquartia (‘IndiaBoats) has reasonable grounds to suspect that
              such information is untrue, inaccurate, not current or incomplete,
              Aquartia (‘IndiaBoats) has the right to suspend or terminate the
              User's registration and refuse any and all current or future use
              of the Website and/or any Service.
            </p>
            <p>
              Furthermore, the User grants Aquartia (‘IndiaBoats) the right to
              disclose to third parties Registration Data to the extent
              necessary for the purpose of carrying out the Services.
            </p>
            <p>
              Without prejudice to the other remedies available to Aquartia
              (‘IndiaBoats) under this agreement, the TOS or under applicable
              law, Aquartia (‘IndiaBoats) may limit the user's activity, or end
              the user's listing, warn other users of the user's actions,
              immediately temporarily/indefinitely suspend or terminate the
              user's registration, and/or refuse to provide the user with access
              to the website if:
            </p>
            <p>
              (a) the user is in breach of this agreement, the tos and/or the
              documents it incorporates by reference;
              <br />
              (b) Aquartia (‘IndiaBoats) is unable to verify or authenticate any
              information provided by the user; or
              <br />
              (c) Aquartia (‘IndiaBoats) believes that the user's actions may
              infringe on any third party rights or breach any applicable law or
              otherwise result in any liability for the user, other users of the
              website and/or Aquartia (‘IndiaBoats).
            </p>
            <p>
              Aquartia (‘IndiaBoats) may at any time in its sole discretion
              reinstate suspended users. Once the user have been indefinitely
              suspended the user may not register or attempt to register with
              Aquartia (‘IndiaBoats) or use the website in any manner whatsoever
              until such time that the user is reinstated by Aquartia
              (‘IndiaBoats). Notwithstanding the foregoing, if the user breaches
              this agreement, the tos or the documents it incorporates by
              reference, Aquartia (‘IndiaBoats) reserves the right to recover
              any amounts due and owing by the user to Aquartia (‘IndiaBoats)
              and/or the service provider and to take strict legal action as
              Aquartia (‘IndiaBoats) deems necessary.
              <br />
            </p>
            <p>
              Aquartia (‘IndiaBoats) may provide the User with content such as
              sound, photographs, graphics, video or other material contained in
              sponsor advertisements or information. This material may be
              protected by copyrights, trademarks or other intellectual property
              rights and laws. The User may use this material only as expressly
              authorized by Aquartia (‘IndiaBoats) and shall not copy, transmit
              or create derivative works of such material without express
              authorization from Aquartia (‘IndiaBoats)
            </p>
            <p>
              The User acknowledges and agrees that they shall not upload, post,
              reproduce or distribute any content on or through the Website that
              is protected by copyright or other proprietary right of a third
              party, without obtaining the permission of the owner of such
              right. Any copyrighted or other proprietary content distributed on
              or through the Website with the consent of the owner must contain
              the appropriate copyright or other proprietary rights notice. The
              unauthorized submission or distribution of copyrighted or other
              proprietary content is illegal and could subject the User to
              personal liability or criminal prosecution.
              <br />
            </p>
            <p>
              None of the provisions of this Agreement, terms and conditions,
              notices or the right to use the Website by the User contained
              herein or any other section or pages of the Website and/or the
              Linked Sites, shall be deemed to constitute a partnership between
              the User and Aquartia (‘IndiaBoats) and no party shall have any
              authority to bind or shall be deemed to be the agent of the other
              in any way. It may be noted, however, that if by using the
              Website, the User authorizes Aquartia (‘IndiaBoats) and its agents
              to access third party sites designated by them or on their behalf
              for retrieving requested information, the User shall be deemed to
              have appointed Aquartia (‘IndiaBoats) and its agents as their
              agent for this purpose.
              <br />
            </p>
            <p>
              The headings and subheadings herein are included for convenience
              and identification only and are not intended to describe,
              interpret, define or limit the scope, extent or intent of this
              Agreement, the TOS or the right to use the Website by the User
              contained herein or any other section or pages of the Website or
              any Linked Sites in any manner whatsoever.
              <br />
            </p>
            <p>
              The terms and conditions herein shall apply equally to both the
              singular and plural form of the terms defined. Whenever the
              context may require, any pronoun shall include the corresponding
              masculine and feminine. The words "include", "includes" and
              "including" shall be deemed to be followed by the phrase "without
              limitation". Unless the context otherwise requires, the terms
              "herein", "hereof", "hereto", "hereunder" and words of similar
              import refer to this Agreement as a whole.
              <br />
            </p>
            <p>
              The User agrees to indemnify, defend and hold harmless Aquartia
              (‘IndiaBoats) from and against any and all losses, liabilities,
              claims, damages, costs and expenses (including legal fees and
              disbursements in connection therewith and interest chargeable
              thereon) asserted against or incurred by Aquartia (‘IndiaBoats)
              that arise out of, result from, or may be payable by virtue of,
              any breach or non-performance of any representation, warranty,
              covenant or agreement made or obligation to be performed by the
              User pursuant to this Agreement and/or the TOS.
              <br />
            </p>
            <p>
              If any provision of this Agreement is determined to be invalid or
              unenforceable in whole or in part, such invalidity or
              unenforceability shall attach only to such provision or part of
              such provision and the remaining part of such provision and all
              other provisions of this Agreement shall continue to be in full
              force and effect.
              <br />
            </p>
            <p>
              Either the User or Aquartia (‘IndiaBoats) may terminate this
              Agreement and a Service with or without cause at any time to be
              effective immediately.
            </p>
            <p>
              The User agrees that Aquartia (‘IndiaBoats) may under certain
              circumstances and without prior notice, immediately terminate the
              User's user id and access to the Website/Services. Causes for
              termination may include, but shall not be limited to, breach by
              the User of this Agreement or the TOS, requests by enforcement or
              government agencies, requests by the User, non-payment of fees
              owed by the User in connection with the Services as specified in
              the applicable TOS.
            </p>
            <p>
              This Agreement may be terminated by either the User or Aquartia
              (‘IndiaBoats) through a written notice to the other. Aquartia
              (‘IndiaBoats) shall not be liable to the User or any third party
              for termination of any Service. Should the User object to any
              terms and conditions of this Agreement, any TOS or become
              dissatisfied with the Service in any way, the User's only recourse
              is to immediately: (a) discontinue use of the Website/Service; and
              (b) notify Aquartia (‘IndiaBoats) of such discontinuance.
            </p>
            <p>
              Upon termination of the Service, User's right to use the
              Website/Services and software shall immediately cease. The User
              shall have no right and Aquartia (‘IndiaBoats) shall have no
              obligation thereafter to execute any of the User's uncompleted
              tasks or forward any unread or unsent messages to the User or any
              third party. Once the User's registration or the Services are
              terminated, cancelled or suspended, any data that the User has
              stored on the Website may not be retrieved later.
            </p>
            <p>
              All notices and communications (including those related to changes
              in the TOS, Service, termination of Service etc.,) shall be in
              writing, in English and shall deemed given if delivered personally
              or by commercial messenger or courier service, or mailed by
              registered or certified mail (return receipt requested) or sent
              via email/facsimile (with acknowledgment of complete transmission)
              to the following address:
            </p>
            <ul>
              <li>
                If to Aquartia (‘IndiaBoats), at customercare@indiaboats.in or
                at the address posted on the Website.
                <br />
              </li>
              <li>
                If to a non registered User, at the communication and/or email
                address specified in the application form availing of a Aquartia
                (‘IndiaBoats) Service.
                <br />
              </li>
              <li>
                If to a registered User, at the communication and/or email
                address specified in the registration form.
              </li>
            </ul>
            <p>
              Notice shall be deemed to have been served 48 hours after it has
              been sent, dispatched, displayed, as the case may be, unless,
              where notice has been sent by email, it comes to the knowledge of
              the sending party, that the email address is invalid.
              <br />
            </p>
            <p>
              This agreement and each TOS shall be governed by and constructed
              in accordance with the laws of India without reference to conflict
              of laws principles and disputes arising in relation hereto shall
              be subject to the exclusive jurisdiction of the courts of
            </p>
            <p>
              Aquartia (‘IndiaBoats) accepts Visa, MasterCard, American Express,
              select Debit Cards and Net Banking. Other payment methods may be
              added from time to time.
              <br />
              Aquartia (‘IndiaBoats) acts as the agent to those who are
              promoting the water sports for which you. can book or purchase.
              When you book/purchase a yacht/boat, IndiaBoats will be handling
              the transaction and collecting payment for the Vendors
              <br />
              IndiaBoats provides booking on behalf of Various respective
              Vendors and does not control the inventory or its availability and
              pricing.
              <br />
              Bookings/ Charters/items purchased on IndiaBoats are subject to
              handling fee and a non-refundable per order processing fee.
              <br />
              If you do not receive a confirmation number (in the form of a
              confirmation page or email) after submitting payment information,
              or if you experience an error message or service interruption
              after submitting payment information, it is your responsibility to
              confirm the same form your booking history or with the Customer
              Service Department whether or not your order has been placed. Only
              you may be aware of any problems that may occur during the
              purchase process. IndiaBoats will not be responsible for losses
              (monetary or otherwise) if you assume that an order was not placed
              because you failed to receive confirmation.
              <br />
              Before Booking/purchasing, carefully review your booking details.
              IndiaBoats prohibits exchanges or refunds after the purchase and
              cancellation would be subject to terms and conditions defined by
              the respective vendor.
              <br />
              Some Orders will be processed only after a billing address, and
              other billing information, has been verified. Occasionally, we
              receive incorrect billing or credit card account information for a
              booking order that can delay processing and delivery. In these
              cases, IndiaBoats customer service will attempt to contact you,
              using the information provided at the time of purchase. If
              IndiaBoats is unable to reach you after its initial attempt,
              IndiaBoats may cancel your order and may sell your tickets to
              another customer.
              <br />
              IndiaBoats offers multiple delivery options. The options may vary
              from for different bookings/purchases. Currently the following
              delivery options are available:
              <br />
              Email confirmation: Your booking confirmation will be sent via an
              email. This confirmation needs to be printed and shown to the
              booking vendor.
              <br />
              SMS confirmation: Your booking confirmation will be sent via an
              SMS. The SMS details need to be shown to the booking vendor.
              <br />
              If the amount you pay for a Booking is incorrect regardless of
              whether because of an error in a price posted on this web site or
              otherwise communicated to you, or you are able to order a ticket
              before its scheduled on-sale or presale date or you are able to
              order a ticket that was not supposed to have been released for
              sale, then: IndiaBoats will have the right to cancel that ticket
              (or the order for that ticket) and refund to you the amount that
              you paid. This will apply regardless of whether because of human
              error or a transactional malfunction of this web site.
            </p>
            <p>
              Occasionally, Boat booking is postponed by the promoter. Should
              this occur, we will attempt to contact you and refund the amount
              as per the policy of the vendor.
              <br />
              Customer Care If you need help regarding your order or any other
              issue, the best in the company is available. We guarantee a
              response time of one working day and you can reach our customer
              service department at customercare@indiaboats.in
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</>




      <Footer/>
    </>
  );
};

export default Terms;
